import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=1b56da4c&scoped=true&"
import script from "./ListItem.vue?vue&type=script&lang=js&"
export * from "./ListItem.vue?vue&type=script&lang=js&"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=1b56da4c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56da4c",
  null
  
)

export default component.exports